// @flow
import type { Dispatch, GetState } from 'state/types';
import { getIdentitySession } from 'state/selectors';
import { actions as npActions } from 'state/reducers/netPublishReducer';
import { actions as modalPromptActions } from 'portfolio-shared/state/reducers/modalPromptReducer';
import localizedStrings from 'util/localizedStrings';

const { showModalPrompt } = modalPromptActions;
const {
  deleteSite: deleteSiteAction,
  getNPServerStatus: getNPServerStatusAction,
  getSites: getSitesAction,
  setSiteEnabled: setSiteEnabledAction,
} = npActions;

export function getSites() {
  return async function getSites(dispatch: Dispatch, getState: GetState) {
    const session = getIdentitySession(getState());
    if (session) {
      await dispatch(getSitesAction(session));
    }
  };
}

export function getNPServerStatus() {
  return async function getNPServerStatus(
    dispatch: Dispatch,
    getState: GetState
  ) {
    const session = getIdentitySession(getState());
    if (session) {
      await dispatch(getNPServerStatusAction(session));
    }
  };
}

export function deleteNPSite(siteId: string) {
  return async function getNPServerStatus(
    dispatch: Dispatch,
    getState: GetState
  ) {
    const session = getIdentitySession(getState());
    if (session) {
      await dispatch(
        showModalPrompt({
          isButton2Default: true,
          message: localizedStrings.NP_DELETE_SITE_CONFIRMATION,
          dataTestName: 'delete-site-modal',
          onButton2: async function doDelete() {
            await dispatch(deleteSiteAction(session, siteId));
            await dispatch(getSitesAction(session));
          },
        })
      );
    }
  };
}

export function setNPSiteEnabled(siteId: string, enabled: boolean) {
  return async function getNPServerStatus(
    dispatch: Dispatch,
    getState: GetState
  ) {
    const session = getIdentitySession(getState());
    if (session) {
      await dispatch(setSiteEnabledAction(session, siteId, enabled));
      await dispatch(getSitesAction(session));
    }
  };
}



// WEBPACK FOOTER //
// ./src/state/commands/netPublishCommands.js